import React from 'react';
import './Header.scss';

const Header = (): JSX.Element => {
  return (
    <div className="Header">
      <h1 className="Header-Title">SigmaJS Demo - React</h1>
    </div>
  );
};

export default Header;
